module.exports = __webpack_public_path__ + "static/media/pasar-itv.c8b47abc.png";